import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { addHttpIfMissing } from '@backrs_ui/common-ui/src/utils/app.util';
import { Box, Typography } from '@mui/material';
import { InternshipLineItem } from './InternshipLineItem';
var _a = appStrings.modules.nugget.internship, QUICK_LOOK = _a.QUICK_LOOK, SECTION_TITLES = _a.SECTION_TITLES, notAvailable = _a.notAvailable;
export function QuickLook(_a) {
    var _b;
    var _c;
    var internshipInfo = _a.internshipInfo;
    var valueMap = (_b = {},
        _b[QUICK_LOOK.type] = internshipInfo.role_type || notAvailable,
        _b[QUICK_LOOK.path] = ((_c = internshipInfo.careerPaths) === null || _c === void 0 ? void 0 : _c.map(function (careerPath) { return careerPath.name; }).join(', ')) || notAvailable,
        _b[QUICK_LOOK.track] = notAvailable,
        _b[QUICK_LOOK.industry] = internshipInfo.industry_name || notAvailable,
        _b[QUICK_LOOK.location] = internshipInfo.location || notAvailable,
        _b[QUICK_LOOK.deadline] = internshipInfo.apply_by_date
            ? new Date(internshipInfo.apply_by_date).toLocaleDateString()
            : notAvailable,
        _b);
    return (_jsxs(Box, { sx: containerStyle, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "body1", sx: sectionTitleStyle, children: SECTION_TITLES.quickLook }), Object.entries(valueMap).map(function (_a) {
                        var title = _a[0], value = _a[1];
                        return (_jsx(InternshipLineItem, { title: title, value: value }, title));
                    })] }), (internshipInfo.application_url || internshipInfo.company_website) && (_jsx(Box, { component: "a", href: addHttpIfMissing(internshipInfo.application_url || internshipInfo.company_website || ''), target: "_blank", children: _jsx(Typography, { variant: "body1", sx: linkStyle, children: SECTION_TITLES.applicationLink }) }))] }));
}
var sectionTitleStyle = {
    fontWeight: 700,
    color: appColors.color.blue1,
    mb: 1,
};
var containerStyle = {
    justifyContent: 'space-between',
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
};
var linkStyle = {
    color: appColors.color.blue1,
    textDecoration: 'underline',
    textDecorationColor: appColors.color.blue1,
    fontWeight: 700,
    mt: 1,
};
